import { css } from "@emotion/css";

import { grey, red, yellow } from "@/modules/theme/utils/colors";
import { Theme } from "@/modules/theme/utils/createTheme";

export const createRadioStyles = ({
  spacing,
  typography,
  palette,
  boxShadows,
}: Theme) => {
  return {
    root: css({
      display: "inline-flex",
      flexDirection: "column",
      position: "relative",
      marginBottom: spacing(1),
    }),
    radio: css({
      opacity: 0,
      position: "absolute",
      left: 0,
      margin: 0,

      "&[disabled]": {
        "& + label": {
          opacity: 0.5,
          cursor: "not-allowed",
        },
      },
      "&:checked": {
        "& + label::before": {
          boxShadow: boxShadows.checkbox,
          width: spacing(2.5),
          height: spacing(2.5),
          backgroundColor: palette.primary.light,
        },
        "& + label::after": {
          content: "''",
          position: "absolute",
          width: spacing(0.75),
          height: spacing(0.75),
          left: spacing(1.25),
          top: "50%",
          transform: "translate(-50%, -50%)",
          borderRadius: "50%",
          backgroundColor: yellow[900],
        },
      },
      "&:focus": {
        "& + label::before": {
          border: `1px solid ${grey[500]}`,
        },
      },
    }),
    label: css({
      display: "inline-flex",
      alignItems: "center",
      padding: spacing([0, 3.5]),
      position: "relative",
      minHeight: spacing(2.5),
      cursor: "pointer",
      outline: 0,
      fontSize: typography.fontSize.default,
      color: palette.secondary.textDark,

      "&:before": {
        width: spacing(2.5),
        height: spacing(2.5),
        color: "transparent",
        display: "block",
        content: "''",
        borderRadius: "50%",
        transition: `background-color 0.25s, border-color 0.25s`,
        background: grey[300],
        position: "absolute",
        top: "50%",
        transform: "translateY(-50%)",
        left: 0,
        boxSizing: "border-box",
      },

      "&:hover::before": {
        border: `1px solid ${grey[400]}`,
      },
    }),
    errorHidden: css({
      display: "none",
    }),
    errorLabel: css({
      color: red[400],

      "&:before": {
        backgroundColor: palette.default.background,
        border: `1px solid ${red[400]}`,
      },
    }),
    description: css({
      color: grey[600],
      fontSize: typography.pxToRem(11),
      maxWidth: 290,
      margin: spacing([0.5, 1, 0, 3.5]),
    }),
  };
};
